import LogoutButton from '@/components/LogoutButton'
import { Loader } from '@/components/custom-components/Loader'
import OnboardingHeader from '@/components/onboarding/OnboardingHeader'
import { ProtectedArea } from '@/components/protectedArea'
import useMonitorSubscription from '@/hooks/useMonitorSubscription'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/verify-subscription')({
  component: VerifySubscription,
})

type SearchParams = {
  redirect?: string
}

function VerifySubscription() {
  const { redirect } = Route.useSearch() as SearchParams

  const { subscriptionSuccessful: isSubscribed } = useMonitorSubscription(true)
  useEffect(() => {
    if (!isSubscribed) return

    if (redirect?.toString().includes('/')) {
      window.location.href = redirect
    } else {
      window.location.href = '/feeds/templates'
    }
  }, [isSubscribed])

  return (
    <ProtectedArea>
      <div className="bg-brandgrad bg-no-repeat bg-center bg-cover h-screen flex flex-col">
        {/* Top header row */}
        <div className="flex justify-between items-center gap-2">
          <OnboardingHeader />
          <div className="pr-5 lg:pr-10 pt-5 lg:pt-10">
            <LogoutButton />
          </div>
        </div>

        {/* Centered card */}
        <div className="flex-1 flex justify-center items-center">
          <div className="rounded-lg bg-white p-5 w-11/12 lg:w-[32rem] flex flex-col gap-6 border">
            <div className="flex flex-col items-center gap-4">
              <h4 className="text-2xl text-center text-themeforeground font-semibold">Verifying your subscription</h4>
              <p className="text-center">
                We are verifying your subscription. This may take a few seconds. You will be redirected to the dashboard
                when it is complete.
              </p>
              <div className="flex justify-center items-center w-full py-6 h-14">
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ProtectedArea>
  )
}

export default VerifySubscription
